import { shortenString } from "@lib/helpers/StringHelper";
import { ProviderTransactionConfig } from "@lib/types/Transaction";
import { Divider, Typography } from "antd";
import { useMemo } from "react";

type Props = {
  config: ProviderTransactionConfig;
};

export default function ProviderTransactionConfigName({ config }: Props) {
  const previewConfig = useMemo(() => {
    if (config?.config?.type === "card") {
      return shortenString(config?.config?.cardNumber, 10);
    }
    return shortenString(config?.config?.accountNumber, 10);
  }, [config]);

  return (
    <Typography.Text
      ellipsis
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
      }}
    >
      <span>{config?.name}</span>
      <Divider type="vertical" />
      <span>
        {config?.from} <small>{config?.currency}</small> - {config?.to}{" "}
        <small>{config?.currency}</small>
      </span>
      <Divider type="vertical" />
      <Typography.Text style={{ fontSize: 12 }}>
        {previewConfig}
      </Typography.Text>
    </Typography.Text>
  );
}
